<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="580px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    custom-class="complaint-dialog"
    center
  >
    <div class="complaint-cont">
      <div class="header-wrap">
        <p class="title">举报</p>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="data-wrap">
        <p class="title">
          <span>举报原因</span><span class="is-require">*</span>
        </p>
        <ul class="type-list">
          <li
            @click="handleOptionClick(val)"
            class="type-item"
            v-for="(item, val) in typeMap"
            :key="val"
          >
            <label class="custom-radio">
              <input
                type="radio"
                :value="val"
                :disabled="true"
                :checked="judgeChecked(val)"
              />
              <span class="radio-circle"></span>
            </label>
            <p class="option">{{ item }}</p>
          </li>
        </ul>
        <p class="title">举报描述</p>
        <el-input
          class="complaint-input"
          type="textarea"
          placeholder="请详细描述举报原因，便于平台判断违规情况，最多输入200字"
          v-model.trim="content"
          maxlength="200"
          resize="none"
        >
        </el-input>
        <!-- 图片上传 -->
        <UploadImages
          class="complaint-upload-wrap"
          v-model="imgList"
          :sts-api="'/v1/cos/getSign'"
          :sts-params="uploadParams"
          :limit="3"
          :data-type="'object'"
          :limitSize="32"
        />
      </div>
      <div class="footer-wrap">
        <button @click="handleClose" class="cancel-btn">取消</button>
        <button @click="handleSubmit" class="submit-btn">确认</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { submitReport } from "@saas/service-api/src/homework/index";
import { UploadImages } from "@saas/components";
export default {
  data() {
    return {
      dialogVisible: false,
      typeMap: {
        1: "色情低俗",
        2: "不实信息",
        3: "未成年相关",
        4: "违法违规",
        5: "违规营销",
        6: "侵犯权益",
        7: "政治敏感",
        8: "危害人身安全",
        9: "其他",
      },
      complaint_type: "",
      content: "",
      imgList: [],
      data_id: null,
    };
  },
  methods: {
    handleSubmit() {
      if (!this.complaint_type) {
        this.$showToast("请选择举报原因");
        return;
      }
      let params = {
        scene: 1,
        complaint_type: Number(this.complaint_type),
        content: this.content,
        accessory: this.imgList.map((item) => item.url).join(","),
        data_id: this.data_id,
      };
      submitReport(params).then((res) => {
        if (res.code === 1) {
          this.$message.success("举报成功");
          this.handleClose();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.complaint_type = "";
      this.content = "";
      this.imgList = [];
      this.data_id = null;
    },
    handleOptionClick(value) {
      this.complaint_type = value;
    },
    showDialog(id) {
      this.data_id = Number(id);
      this.dialogVisible = true;
    },
  },
  computed: {
    judgeChecked() {
      return (value) => {
        return this.complaint_type === value;
      };
    },
    uploadParams() {
      return {
        materialType: 102,
      };
    },
  },
  components: {
    UploadImages,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .complaint-dialog {
  max-width: 95%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  border-radius: 16px;
  min-height: 456px;
  padding: 16px 14px 0 24px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .header-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 18px;
    color: #0d1400;
    line-height: 25px;
    i {
      padding: 3px;
      position: absolute;
      top: 3px;
      right: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #4e5969;
      cursor: pointer;
    }
  }

  .type-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 4px 0;
  }

  .type-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 12px;
    .custom-radio {
      position: relative;
      cursor: pointer;
      user-select: none;
    }

    .custom-radio input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
    .radio-circle {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      background: #ffffff;
      border-radius: 7px;
      border: 1px solid #e8e8e9;
      border-radius: 50%;
      line-height: 1;
      margin-right: 5px;
    }

    // 选中状态样式
    .custom-radio input:checked ~ .radio-circle {
      border: none;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      position: relative;
      &::after {
        content: "";
        position: absolute;
        display: flex;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        overflow: hidden;
        transition: transform 0.15s ease-in 0.05s;
        background-image: url("../../../assets/images/icon/check-icon.png");
        background-size: 100% 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .option {
      font-weight: 400;
      font-size: 14px;
      color: #515350;
      line-height: 20px;
      min-width: 89px;
    }
  }

  .data-wrap {
    .title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #0d1400;
      line-height: 21px;
      margin-bottom: 8px;
    }
    .is-require {
      font-weight: 500;
      font-size: 15px;
      color: #ff265c;
      line-height: 21px;
      margin-left: 4px;
      position: relative;
      top: 3px;
    }
  }

  .complaint-input {
    margin-bottom: 8px;
    .el-textarea__inner {
      height: 129px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e5e6eb;
      font-size: 14px;
      color: #0d1400;
      padding: 10px;
      &::placeholder {
        font-size: 15px;
        color: #858687;
        font-weight: 400;
      }
    }
  }

  .complaint-upload-wrap .pc-upload-container {
    .el-upload {
      width: 75px;
      height: 75px;
      background: #f7f8f9;
      border-radius: 12px;
    }
    .upload-icon {
      width: 18px;
      height: 18px;
    }
    .upload-text {
      font-weight: 400;
      font-size: 11px;
      color: #515350;
      line-height: 16px;
    }
    .image-item {
      width: 75px;
      height: 75px;
      border-radius: 12px;
      border: none;
      margin-right: 8px;
    }
    .close-icon {
      width: 12px;
      height: 12px;
      top: -2px;
      right: -3px;
    }
  }
  .footer-wrap {
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
    padding-bottom: 20px;
    .cancel-btn,
    .submit-btn {
      width: 70px;
      height: 36px;
      background: #f2f3f5;
      border-radius: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #4e5969;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 16px;
    }
    .submit-btn {
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      color: #ffffff;
    }
  }
}
</style>
